import { render, staticRenderFns } from "./Step4_AddExplanation.vue?vue&type=template&id=39afa07d&"
import script from "./Step4_AddExplanation.vue?vue&type=script&lang=js&"
export * from "./Step4_AddExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports